var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16659 3.33325H5.83325C4.45254 3.33325 3.33325 4.45254 3.33325 5.83325L3.33325 14.1666C3.33325 15.5473 4.45254 16.6666 5.83325 16.6666H9.16659M13.3333 13.3333L16.6666 9.99992M16.6666 9.99992L13.3333 6.66659M16.6666 9.99992L7.49992 9.99992",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogoutIcon);
export default __webpack_public_path__ + "static/media/navLogoutIcon.c1b2a6750100dc766cf138a74d6f9766.svg";
export { ForwardRef as ReactComponent };